/** Provider-safe tool ids (OpenAI: ^[a-zA-Z0-9_-]+$). Canonical names keep dots. */
const PREFIX = 'mhub_';
const DOT_TOKEN = '_d_';
export function canonicalToolToProvider(canonical) {
    if (!canonical.includes('.'))
        return canonical;
    return PREFIX + canonical.replace(/\./g, DOT_TOKEN);
}
export function providerToolToCanonical(provider) {
    if (!provider.startsWith(PREFIX))
        return provider;
    return provider.slice(PREFIX.length).replace(new RegExp(DOT_TOKEN, 'g'), '.');
}
export function assertCanonicalToolNamesSafe(names) {
    for (const name of names) {
        if (name.startsWith(PREFIX)) {
            throw new Error(`Canonical tool name must not use provider prefix: ${name}`);
        }
        if (name.includes(DOT_TOKEN)) {
            throw new Error(`Canonical tool name must not contain transport token: ${name}`);
        }
    }
}
//# sourceMappingURL=toolNameTransport.js.map